import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './Center.st.css.js';
class Center extends React.Component {
    render() {
        const { children } = this.props;
        return React.createElement("div", { className: classes.center }, children);
    }
}
Center.propTypes = {
    children: PropTypes.node,
};
export default Center;
//# sourceMappingURL=Center.js.map